var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrystal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 59,
    viewBox: "0 0 69 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49226 33.4923L23.1863 50.1863C28.5196 55.5196 31.1863 58.1863 34.5 58.1863C37.8137 58.1863 40.4804 55.5196 45.8137 50.1863L62.5077 33.4923C65.9098 30.0902 67.6109 28.3891 68.133 26.1773C68.6552 23.9655 67.8944 21.6833 66.373 17.1189L64.3968 11.1904C62.6367 5.9102 61.7567 3.27013 59.6616 1.76006C57.5665 0.25 54.7836 0.25 49.2179 0.25H19.7821C14.2164 0.25 11.4335 0.25 9.33839 1.76006C7.24329 3.27013 6.36327 5.9102 4.60321 11.1904L2.62703 17.1189C1.10558 21.6833 0.344847 23.9655 0.866991 26.1773C1.38913 28.3891 3.09018 30.0902 6.49226 33.4923Z",
    fill: "#7C98F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystal);
export default __webpack_public_path__ + "static/media/crystal.19a2285b2240e60b016685407e6735f5.svg";
export { ForwardRef as ReactComponent };